import { atom } from "recoil";

export const sessionTitleState = atom<string>({
  key: "sessionTitleState",
  default: "",
});